// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.despatch_container_despatch__dVH-U {
    display: flex;
    flex: 5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.despatch_featuredItem__Ec8rQ {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor: default;
}

.despatch_featured__xo33j {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.despatch_featuredTitleHeader__wyzJT {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.despatch_container_row__3zZ5J {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    flex-direction: column;
    align-content: center;
    align-items: center;
    align-self: center;
}

.despatch_recordDespatchDialog__As5Qc {
    min-width: 70vw !important;
    max-width: 70vw !important;
    min-height: 60%;
    max-height: 90%;
}

.despatch_flex_row_container__AicWO {
    display: inline-flexbox;
    flex-direction: row;
    flex: 11 1;
    width: 100%;
    align-items: flex-start;
    align-content: center;
    justify-content: left;
}

.despatch_widget_container__Vz8eM {
    max-width: 40%;
    min-height: 40%;
    max-height: 50%;
}

.despatch_centeredIconLabel__diGlg {
    align-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/Despatch/despatch.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".container_despatch {\r\n    display: flex;\r\n    flex: 5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor: default;\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.container_row {\r\n    display: flex;\r\n    flex: 1;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    align-self: center;\r\n}\r\n\r\n.recordDespatchDialog {\r\n    min-width: 70vw !important;\r\n    max-width: 70vw !important;\r\n    min-height: 60%;\r\n    max-height: 90%;\r\n}\r\n\r\n.flex_row_container {\r\n    display: inline-flexbox;\r\n    flex-direction: row;\r\n    flex: 11;\r\n    width: 100%;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: left;\r\n}\r\n\r\n.widget_container {\r\n    max-width: 40%;\r\n    min-height: 40%;\r\n    max-height: 50%;\r\n}\r\n\r\n.centeredIconLabel {\r\n    align-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_despatch": `despatch_container_despatch__dVH-U`,
	"featuredItem": `despatch_featuredItem__Ec8rQ`,
	"featured": `despatch_featured__xo33j`,
	"featuredTitleHeader": `despatch_featuredTitleHeader__wyzJT`,
	"container_row": `despatch_container_row__3zZ5J`,
	"recordDespatchDialog": `despatch_recordDespatchDialog__As5Qc`,
	"flex_row_container": `despatch_flex_row_container__AicWO`,
	"widget_container": `despatch_widget_container__Vz8eM`,
	"centeredIconLabel": `despatch_centeredIconLabel__diGlg`
};
export default ___CSS_LOADER_EXPORT___;
